export const BASE_URL = process.env.REACT_APP_ENOTIFIERS_ADMIN_API;

export const CLIENTADMIN_URL = "https://fstca.thefirstock.com";

export const UPLOADFILE_MIDDLEWARE_URL = "https://middleware.thefirstock.tech";
